<template>
	<div
		:class="{
			'three-large-cards': filteredProducts.length < 4,
			'four-cards': filteredProducts.length > 3,
		}"
	>
		<div class="frow-container">
			<div class="frow gutters card-container row-start">
				<div class="card-container-inner">
					<div v-if="loadingState == 'loading'" style="padding-bottom: 80px">
						Loading products...
					</div>
					<div v-if="loadingState == 'error'">
						<h3>Oops!</h3>
						<p style="white-space: normal;">
							Looks like we weren't able to get these products. There might be
							an issue with your connection to the internet or our server might
							be having some trouble. Either way, please give it another shot!
						</p>
						<button class="btn bg--primary" @click="reloadPage()">
							Try again
						</button>
					</div>
					<div
						v-if="filteredProducts"
						v-for="product in filteredProducts"
						class="sleek-card card"
					>
						<a :href="product.link" class="sleek-card--card normal-size">
							<div class="sleek-card--image">
								<img
									class=" lazyloaded"
									:data-src="getImageUrl(product)"
									:alt="product.image && product.image.alt ? product.image.alt : `Image of ${product.title}`"
									:src="getImageUrl(product)"
								/>
							</div>
							<div class="sleek-card--content">
								<h4 class="h7">
									{{ product.title }}
								</h4>
								<span class="button-description">View product</span>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import regeneratorRuntime from "regenerator-runtime";
import { getProductData } from "../utils";
export default {
	name: "ProductCards",
	data() {
		return {
			margin: 20,
			products: [],
			loadingState: "loading",
		};
	},
	props: ["skus"],
	methods: {
		reloadPage() {
			window.location.reload();
		},
    getImageUrl(product) {
      // add fallback for product.image being a string in the old format
      return product.image && product.image.url
          ? product.image.url
          : (product.image || "");

    }
	},
	computed: {
		filteredProducts() {
			return (
				this.products &&
				this.products.length &&
				this.products.filter((p, i) => i < 4)
			);
		},
	},
	async mounted() {
		this.loadingState = "loading";
		this.products = await getProductData(encodeURIComponent(this.skus));
		if (!this.products || this.products.length === 0) {
			this.loadingState = "error";
		} else {
			this.loadingState = "loaded";
		}
	},
};
</script>

<style scoped></style>
